import { Button } from '../button';

export class BannerActionSecondary extends Button {
	constructor() {
		super();

		this.variant = 'tertiary';
		this.size = 'small';
	}

	override connectedCallback(): void {
		super.connectedCallback();

		// This sets the slot to which the banner-action-secondary should be assigned inside the banner-actions component.
		this.setAttribute('slot', 'secondary-action');
	}
}

window.customElements.define(
	'm-banner-action-secondary',
	BannerActionSecondary,
);

declare global {
	interface HTMLElementTagNameMap {
		'm-banner-action-secondary': BannerActionSecondary;
	}
}
